import { render, staticRenderFns } from "./SubmittedInput.vue?vue&type=template&id=47748ee5&scoped=true&"
import script from "./SubmittedInput.vue?vue&type=script&lang=js&"
export * from "./SubmittedInput.vue?vue&type=script&lang=js&"
import style0 from "./SubmittedInput.vue?vue&type=style&index=0&id=47748ee5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47748ee5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
